export const pinnedSort = (a, b) => {
  // Pinned items come before non-pinned items
  if (a.isPinned && !b.isPinned) {
    return -1;
  } else if (!a.isPinned && b.isPinned) {
    return 1;
  } else {
    // Maintain the original order for items with the same pinned status
    return 0;
  }
};
